import { WISE_ALIAS } from './provider-constants';

function isWiseQuote(quote) {
  return quote.alias === WISE_ALIAS;
}

function isPartnerQuote(quote) {
  return quote.partner;
}

function isBankQuote(quote) {
  return quote.providerType === 'bank';
}

function isMoneyTransferProviderQuote(quote) {
  return quote.providerType === 'moneyTransferProvider';
}

export { isWiseQuote, isPartnerQuote, isBankQuote, isMoneyTransferProviderQuote };
